import { Route, Routes } from "react-router-dom";
import Landing from "../components/legacy/Landing";
import LegacyResults from "../components/legacy/Results";
import { logPageView } from "../utils/analytics";
import { useEffect } from 'react';

import HomePage from "../views/HomePage";
import CandidatesPage from "../views/ResultsPage";
import NotFoundPage from "../views/NotFoundPage";
import ArticlePage from "../views/ArticlePage";
import { useLocation } from 'react-router-dom';

const AppRoutes = () => {
  
  const location = useLocation();
  useEffect(() => {
    
    logPageView(location.pathname + location.search);

  }, [location]);

  return (
        <Routes>
          <Route index element={<HomePage />} />

          <Route path="candidates" element={<CandidatesPage />} />

          <Route path="/results" element={<CandidatesPage />} />
          <Route path="/results/dummy" element={<CandidatesPage dummy={true} />} />
          <Route path="/results/2023" element={<CandidatesPage year={2023} />} />

          <Route path="/article/:slug" element={<ArticlePage />} />

          {/* Legacy */}
          <Route path="/legacy" element={<Landing />} />
          <Route path="/legacy/results" element={<LegacyResults />} />

          <Route path="*" element={<NotFoundPage />} />

        </Routes>
  );
};

export default AppRoutes;
